import { compose, withHandlers, withState, lifecycle } from 'recompose';
import config from '../../../config';
import { withSpinnerOnAjax } from '../Spinner';
import { showErrorMsg } from '../ErrorMsg';

const orderLimit = 5;
const orderItemLimit = 5;

// To be deprecated
const getData = (pageNumber = 1) => $.get(`${config.localeApi}/order/list?paginate=true&page=${pageNumber}&limit=${orderLimit}`).fail((resp) => {
  const { errors = null } = resp.responseJSON;
  if (errors) {
    const msg = (typeof (errors) == "string") ? errors : Object.keys(errors).map((key) => (errors[key].join(''))).join('<br/>');
    toastr.warning(msg);
  }
});

const getOptimisedList = (pageNumber = 1) => $.get(`${config.localeApi}/order/optimised-list?paginate=true&page=${pageNumber}&limit=${orderLimit}`).fail((resp) => {
  const {
    errors = '',
  } = resp.responseJSON;

  showErrorMsg(errors);
});

export const getOrderItems = (orderId, pageNumber = 1) => $.get(`${config.localeApi}/order/${orderId}/order-items?paginate=true&page=${pageNumber}&limit=${orderItemLimit}`).fail((resp) => {
  const {
    errors = '',
  } = resp.responseJSON;

  showErrorMsg(errors);
});

const withOrderContainer = compose(
  withState('orders', 'setOrders', []),
  withState('currentPageNumber', 'setCurrentPageNumber', 1),
  withState('lastPageNumber', 'setLastPageNumber', 1),
  withSpinnerOnAjax('getOrdersByPage', getOptimisedList),
  withHandlers({
    getDataByPage: ({ getOrdersByPage, setOrders, setCurrentPageNumber, setLastPageNumber }) => pageNumber => {
      window.scrollTo({ top: 0, right: 0, behavior: 'smooth' });
      getOrdersByPage(pageNumber)
        .done(response => {
          setOrders(response.data.data);
          setCurrentPageNumber(response.data.current_page);
          setLastPageNumber(response.data.last_page);
        })
    }
  }),
  lifecycle({
    componentDidMount() {
      this.shouldCallApi = window.location.pathname.includes('order');
      this.didCallApi = false;
    },
    componentDidUpdate() {
      this.shouldCallApi = window.location.pathname.includes('order');
      if(this.shouldCallApi && !this.didCallApi) {
        this.didCallApi = true;
        let { getOrdersByPage, setOrders, setCurrentPageNumber, setLastPageNumber } = this.props;
        getOrdersByPage()
          .done(response => {
            setOrders(response.data.data);
            setCurrentPageNumber(response.data.current_page);
            setLastPageNumber(response.data.last_page);
          })
      }
    },
  }),
);

export const withOrdersData = compose(
  withOrderContainer
)



// WEBPACK FOOTER //
// ./src/Common/Providers/OrderListApi.js